const en = {
  release: [
    'Թողարկվել է: 23.07.2020',
    'Թողարկվել է: 16.07.2021',
    'Թողարկվել է: 05.05.2022',
    'Թողարկվել է: 15.05.2023',
  ],
  contactUs: {
    title: 'Կապ մեզ հետ',
  },
  contributors: {
    title: 'Ներդրում ունեցողներ',
  },
  tooltipTxt: 'Այո, սա ստեղծվել է առանց LLM-ների:',
};

export default en;
